import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

import { VenuePreviewCard } from './VenuePreviewCard';

export type AdCampaignPreviewProps = {
  venueDetails?: Pick<Venue, 'name' | 'short_description' | 'listimage'>;
};

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const AdCampaignPreview = ({ venueDetails }: AdCampaignPreviewProps) => {
  const { locale } = useIntl();
  const { name, short_description, listimage } = venueDetails ?? {};

  const activeLang = locale as Language;
  const title = name?.find(({ lang }) => lang === activeLang)?.value;
  const shortDescription = short_description?.find(({ lang }) => lang === activeLang)?.value;
  return (
    <StyledRoot>
      {venueDetails && <VenuePreviewCard name={title ?? ''} description={shortDescription} imageUrl={listimage} />}
    </StyledRoot>
  );
};
